// extracted by mini-css-extract-plugin
export default {"viewDiv":"style_viewDiv__f87FK"};